export enum ClientType {
  SALE = "Продажа",
  PURCHASE = "Покупка",
  LOM = "Лом",
}

export interface Client {
  _id: string;
  name: string;
  phone: string;
  totalSoldAmount: number;
  totalPurchasedAmount: number;
  totalPaidAmount: number;
  totalReceivedAmount: number;
  ownerId: string;
  ownerName: string;
  clientType: ClientType;
  totalClientDebt: number;
  totalCompanyDebt: number;
  maxDiscount?: number;
}
